// @flow
import React, {useState, useEffect} from 'react';
import {Card, Typography, Divider, Snackbar} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {Check, Delete, Edit} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import type {PickupMethod} from '../../../../../entities';
import DeleteConfirmationModal from '../../../../products/components/DeleteConfirmationModal/DeleteConfirmationModal';
import {
  useDeleteLogisticPickupRate,
  useGetCurrencyCountry,
  useUpdateLogisticPickupRate,
} from '../../logistic-pickup/utils';
import {customErrorMessage} from '../../logistics/utils/customErrorMessage';
import TiendadaTooltip from '../../../../../elements/tiendada-tooltip';

type Props = {
  rate: PickupMethod,
  isNational: boolean,
  classes: {
    card: string,
    header: string,
    textHeader: string,
    check: string,
    textHeaderName: string,
    buttonsHeader: string,
    deleteButton: string,
    editButton: string,
    containerData: string,
    textGrey: string,
    bold: string,
    notCheck: string,
  },
};

export default function CardPickup(props: Props) {
  const {rate, isNational, classes} = props;

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertOpenError, setAlertOpenError] = useState(false);
  const currency = useGetCurrencyCountry();
  const history = useHistory();
  const {
    deleteRate,
    deleteError,
    deleteSuccess,
    messageError,
  } = useDeleteLogisticPickupRate();
  const {
    isSaving,
    savingError,
    updatePickupRate,
  } = useUpdateLogisticPickupRate();

  const formatDisplayAddress = rate => {
    let address = '';

    if (rate.address2) {
      address += ` ${rate.address2}`;
    }
    if (rate.admin3) {
      address += ` ${rate.admin3.admin3Name}`;
    }
    if (rate.admin2) {
      if (rate.admin3) {
        address += `, ${rate.admin2.admin2Name}`;
      } else {
        address += `${rate.admin2.admin2Name}`;
      }
    }
    if (rate.admin1) {
      address += `, ${rate.admin1.admin1Name}`;
    }
    if (rate.country) {
      address += `, ${rate.country.name}`;
    }

    return address;
  };

  const [showModalDeleteRate, setShowModalDeleteRate] = useState(false);

  const handleModalDeleteClose = () => {
    setShowModalDeleteRate(false);
  };

  const handleDeleteClick = () => {
    setShowModalDeleteRate(false);
    deleteRate(rate.id);
  };

  const handleChangeEnabled = () => {
    // const formattedRateRequest = {
    //   enabled: !rate.enabled,
    //   displayName: rate.displayName,
    // };
    // $FlowFixMe
    updatePickupRate({
      adminRateId: rate.id,
      enabled: !rate.enabled,
    });
  };

  useEffect(() => {
    if (deleteError || savingError) {
      setAlertOpenError(true);
    }
  }, [deleteError, savingError]);

  useEffect(() => {
    if (deleteSuccess) {
      setAlertOpen(true);
    }
  }, [deleteSuccess]);

  return (
    <>
      <Snackbar
        open={alertOpenError}
        autoHideDuration={4000}
        onClose={() => setAlertOpenError(false)}
      >
        <Alert severity="error" onClose={() => setAlertOpenError(false)}>
          {customErrorMessage(messageError)}
        </Alert>
      </Snackbar>
      <Snackbar
        open={alertOpen}
        autoHideDuration={4000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert severity="success" onClose={() => setAlertOpen(false)}>
          Se guardo la configuración correctamente
        </Alert>
      </Snackbar>
      <Card variant="outlined" className={classes.card} key={rate.id}>
        <div className={classes.header}>
          <div className={classes.textHeader}>
            <TiendadaTooltip
              title="Habilitar o deshabilitar esta tarifa de recojo"
              placement="top"
            >
              <button
                className={rate.enabled ? classes.check : classes.notCheck}
                type="button"
                onClick={handleChangeEnabled}
                disabled={isSaving}
              >
                {rate.enabled ? <Check /> : null}
              </button>
            </TiendadaTooltip>
            <div className={classes.textHeaderName}>
              <Typography className={classes.bold}>
                {rate.displayName}
              </Typography>
            </div>
          </div>

          <div className={classes.buttonsHeader}>
            <CustomButton
              className={classes.deleteButton}
              variant="text"
              startIcon={<Delete />}
              onClick={() => setShowModalDeleteRate(true)}
            >
              Eliminar
            </CustomButton>
            <Divider orientation="vertical" flexItem />
            <CustomButton
              className={classes.editButton}
              variant="text"
              startIcon={<Edit />}
              onClick={() => {
                history.push(
                  `/configure/logistics/pickup/${
                    isNational ? 'national' : 'international'
                  }/${rate.id}`
                );
              }}
            >
              Editar
            </CustomButton>
          </div>
        </div>
        {rate.address1 && (
          <div className={classes.textHeaderName}>
            <Typography className={classes.bold}>
              {rate.address1}&nbsp;&nbsp;
            </Typography>
            <Typography>{formatDisplayAddress(rate)}</Typography>
          </div>
        )}

        <div className={classes.containerData}>
          <Typography align="left" className={classes.textGrey}>
            Precio: {currency.symbol} {rate.shippingRates[0].price}
          </Typography>
          <Typography align="left" className={classes.textGrey}>
            Instrucciones de recojo: {rate.description}
          </Typography>
        </div>
      </Card>

      <DeleteConfirmationModal
        title="¿Seguro que quieres eliminar esta tarifa?"
        content="Si lo eliminas no lo podrás recuperar."
        open={showModalDeleteRate}
        handleClose={handleModalDeleteClose}
        handleDeleteClick={handleDeleteClick}
        disabled={isSaving}
      />
    </>
  );
}
